<template>
  <div>
    <div class="is-score">{{showScore}}</div>
    <div class="is-star">
      <img v-if="starsImg[0]" class="lazyload" :data-src="starsImg[0]" alt="" width="31" height="29" />
      <img v-if="starsImg[1]" class="lazyload" :data-src="starsImg[1]" alt="" width="31" height="29" />
      <img v-if="starsImg[2]" class="lazyload" :data-src="starsImg[2]" alt="" width="31" height="29" />
      <img v-if="starsImg[3]" class="lazyload" :data-src="starsImg[3]" alt="" width="31" height="29" />
      <img v-if="starsImg[4]" class="lazyload" :data-src="starsImg[4]" alt="" width="31" height="29" />
    </div>
  </div>
</template>

<script>
  import {breakpoint, assets_path} from '@/_constant/variables';
  import store from '@/_modules/stores';

  export default {
    props: ['score'],
    data() {
      return {
        breakpoint: breakpoint,
        assets_path: assets_path,
        showScore: 0,
        starFull: '/assets/img/common/star1@2x.png',
        starHalf: '/assets/img/common/star-half@2x.png',
        starGray: '/assets/img/common/star-gray@2x.png',
        starsImg: [],
      }
    },
    store,
    mounted() {
      this.showScore = Number(this.score).toFixed(1);
      for (let i = 1; i < 6; i++) {
        if (this.score - i >= 0) {
          //console.log('星');
          this.starsImg.push(this.starFull);
        } else {
          if (this.score - i > -1) {
            //console.log('半星');
            this.starsImg.push(this.starHalf);
          } else {
            //console.log('なし');
            this.starsImg.push(this.starGray);
          }          
        }
      }
    }
  }
</script>
